import { createPortal, useEffect, useState } from "preact/compat";
import ADAIcon from "./icon/ADAIcon";
import { CloseOutlined } from "@ant-design/icons";
import { Drawer } from "antd";

export interface AltTextHelpModalProps {
  open: boolean;
  onClose: () => void;
  isMobile: boolean;
}

export default function AltTextHelpModal({ open, onClose, isMobile }: AltTextHelpModalProps) {
  const modalContent = <div className="content">
    <h3><ADAIcon /> Accessibility Text</h3>
    <p>ADA compliance is a federal law that requires businesses to provide accessible services to individuals with disabilities. Accessibility text makes your images readable.</p>
    <p><b>For menu images</b><br/>
    Briefly describe the dish or item. <i>E.g. "Grilled chicken salad with avocado and tomatoes."</i></p>
    <p><b>For logos and illustrations</b><br/>
    Focus on describing the brand name and essential design elements. <i>E.g. "Cafe logo with green leaf icon."</i></p>
  </div>

  return open ?
  isMobile ?
  <Drawer
    className="alt-text-drawer alt-text-help-drawer"
    open={open} 
    onClose={onClose} 
    closeIcon={<CloseOutlined/>} 
    placement="bottom" 
    zIndex={120} 
    height={'55vh'}
    push={false}>
    {modalContent}
  </Drawer>
  :
  createPortal(<div>
    <div className="modal-back" style={{zIndex: 106}} onClick={onClose} />
    <div className="modal alt-text-help-modal" onClick={e => e.stopPropagation()}>
      <div onClick={onClose} className="close-btn"><CloseOutlined/></div>
      {modalContent}
    </div>
  </div>, document.getElementById('modals')!) : null;
}
